module.exports = __webpack_public_path__ + "img/one.cf625b30.png";